import { CSSProperties, FC } from "react";
import { Table } from "antd";
import { clsx } from "clsx";
import { DiscountingTrend } from "../../../../types/IntelligenceTypes";
import styles from "./MarketTrendsCommon.module.less";

const { Column } = Table;

interface DiscontTrendsProps {
    data?: DiscountingTrend[];
    style?: CSSProperties;
}

export const DiscountTrends: FC<DiscontTrendsProps> = ({ data, style }) => {
    if (!data?.length) return null;

    return (
        <div style={style}>
            <div className={clsx(styles.tableTitle, "sectionTitle")}>
                Discounting and seasonal pricing trends
            </div>
            <Table dataSource={data} pagination={false} size="small">
                <Column
                    title="
Timing Trends for Discounts"
                    dataIndex="timingTrend"
                    width={334}
                />
                <Column title="End-of-Quarter/Year Patterns" dataIndex="pattern" width={334} />
                <Column title="Anecdotal Examples" dataIndex="example" />
            </Table>
        </div>
    );
};
